import { z } from 'zod';
import { URLOrHashSchema, ThumbnailSchema } from './primitives';

export const ProjectStatusSchema = z.enum(['shipped', 'oss', 'research', 'wip']);

export const ProjectSchema = z.object({
  name: z.string(),
  status: ProjectStatusSchema,
  desc: z.string(),
  tags: z.array(z.string()),
  href: URLOrHashSchema,
  thumbnail: ThumbnailSchema,
});

export const ProjectsSchema = z.object({
  items: z.array(ProjectSchema).min(1),
});

export type Project = z.infer<typeof ProjectSchema>;
export type ProjectStatus = z.infer<typeof ProjectStatusSchema>;
export type Projects = z.infer<typeof ProjectsSchema>;
